import { createSelector } from 'reselect';
import { KEY } from '.';
import { GlobalState } from 'store/types';

const getDeliveryLogState = (state: GlobalState) => state[KEY];

const selectDeliveryLog = createSelector(getDeliveryLogState, (state) => state);

const selectExportData = createSelector(getDeliveryLogState, (state) => state.export.data);

const selectExportPending = createSelector(getDeliveryLogState, (state) => state.export.pending);

const selectPriceTypes = createSelector(getDeliveryLogState, (state) => state.priceTypes);

const selectPriceTypesPending = createSelector(getDeliveryLogState, (state) => state.priceTypesPending);

const selectSettlementReport = createSelector(getDeliveryLogState, (state) => state.settlementReport);

const selectSettlementReportData = createSelector(getDeliveryLogState, (state) => state.settlementReport.data);

const selectSettlementReportTotal = createSelector(getDeliveryLogState, (state) => state.settlementReport.total);

const selectSettlementReportPending = createSelector(getDeliveryLogState, (state) => state.settlementReport.pending);

const selectSalesReport = createSelector(getDeliveryLogState, (state) => state.salesReport);

const selectSalesReportData = createSelector(getDeliveryLogState, (state) => state.salesReport.data);

const selectSalesReportTotal = createSelector(getDeliveryLogState, (state) => state.salesReport.total);

const selectSalesReportPending = createSelector(getDeliveryLogState, (state) => state.salesReport.pending);

const selectSalesReportByCardType = createSelector(getDeliveryLogState, (state) => state.salesReportByCardType);

const selectSalesReportByCardTypeData = createSelector(
  getDeliveryLogState,
  (state) => state.salesReportByCardType.data
);

const selectSalesReportByCardTypePending = createSelector(
  getDeliveryLogState,
  (state) => state.salesReportByCardType.pending
);

export const selectors = {
  selectDeliveryLog,
  selectExportData,
  selectExportPending,
  selectPriceTypes,
  selectPriceTypesPending,
  selectSettlementReport,
  selectSettlementReportData,
  selectSettlementReportTotal,
  selectSettlementReportPending,
  selectSalesReport,
  selectSalesReportData,
  selectSalesReportTotal,
  selectSalesReportPending,
  selectSalesReportByCardType,
  selectSalesReportByCardTypeData,
  selectSalesReportByCardTypePending
};
